import { memo, useMemo } from "react"
import type { ProductLayoutType } from "../../UserData/_stores/UserPrefsStore"
import { ProductCardWrapper } from "./ProductDesign"
import { ProductSkeleton } from "./ProductSkeleton"

interface Props {
  count: number,
  layout: ProductLayoutType
  showActions?: boolean
  showSelection?: boolean
  showSecondaryActions?: boolean
}

export default memo(function ProductSkeletonList(props:Props) {
  const loadingGrid = useMemo(() => {
    const listSkeletons = []

    for (let i = 0; i < props.count; i++) {
      listSkeletons.push(<ProductCardWrapper key={i} item className={props.layout === 'list' ? 'list-view' : ''}>
        <ProductSkeleton
          listView={props.layout === 'list'}
          showActions={props.showActions}
          showSelection={props.showSelection}
          showSecondaryActions={props.showSecondaryActions}
        />
      </ProductCardWrapper>)
    }

    return listSkeletons
  }, [props.count, props.layout, props.showActions, props.showSelection, props.showSecondaryActions])

  return loadingGrid
})
